import { Button } from '@creditornot/cb-button';
import { colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Typography } from 'common/typography';
import { BREAKPOINT_MOBILE } from 'modules/insights-v2/constants';

import scooterImage from '../../images/scooter-image.webp';
import WoltPlusLogo from '../WoltPlusLogo';

type WoltPlusBannerProps = {
  ctaLink: string;
  onCtaClick: () => void;
  onDismissClick: () => void;
};

const Root = styled.div`
  border-radius: 16px;
  background-color: ${colors.wolt72};
  padding: 30px 40px 20px;
  margin: 24px;
  display: flex;
  justify-content: space-between;

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    flex-direction: column-reverse;
    align-items: center;
    padding: 20px;
  }
`;

const Information = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  min-width: 25%;
  max-width: 1000px;
  gap: 2em;
  color: ${cbSemanticCssVars.surfaceMain};
  fill: ${cbSemanticCssVars.surfaceMain};

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    text-align: center;
  }
`;

const HeaderText = styled.span`
  margin-inline-end: 0.1em;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 15px;

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    flex-direction: column;
  }
`;

const CtaButton = styled(Button)`
  color: ${colors.wolt100};
`;

const WoltPlusBanner = ({ ctaLink, onCtaClick, onDismissClick }: WoltPlusBannerProps) => {
  const history = useHistory();

  const handleCtaClick = () => {
    onCtaClick();

    if (ctaLink.startsWith('http')) {
      window.open(ctaLink, '_blank');
      return;
    }

    history.push(ctaLink);
  };

  return (
    <Root>
      <Information>
        <Typography.Heading4>
          <HeaderText>
            <FormattedMessage id="insights.wolt-plus.heading" />
          </HeaderText>
          <WoltPlusLogo />
        </Typography.Heading4>

        <Typography.Body1>
          <FormattedMessage id="insights.wolt-plus.content" />
        </Typography.Body1>

        <ButtonsContainer>
          <CtaButton onClick={handleCtaClick} variant="white" size="large">
            <FormattedMessage id="insights.wolt-plus.tell-me-more" />
          </CtaButton>
          <Button onClick={onDismissClick} variant="blue" size="large">
            <FormattedMessage id="insights.wolt-plus.dismiss" />
          </Button>
        </ButtonsContainer>
      </Information>

      <img src={scooterImage} width={300} />
    </Root>
  );
};

export default WoltPlusBanner;
